import { createSlice } from '@reduxjs/toolkit';

import { getAllCurrencies } from './actions';

const initialState = {
  data: [],
  isLoading: false,
  isError: false,
  detailAccountBank: {},
  errorMessage: '', // kalo retry setelah error, harus hapus errorMessage dan isError!
};

export const currency = createSlice({
  name: 'currency',
  initialState,
  reducers: {
    // reducers goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCurrencies.pending, (state) => {
        state.data = [];
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = '';
      })
      .addCase(getAllCurrencies.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getAllCurrencies.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      });
  },
});

export default currency.reducer;
